import axios from 'axios';
import { API_URLS } from '../api/config';

interface AudioMessageResponse {
  response: string;
  transcript: string;
}

export const sendAudioMessage = async (
  audioBlob: Blob,
  sessionId: string,
  tutorId: string,
  languageCode: string,
  platform: string = 'web'
): Promise<AudioMessageResponse> => {
  const formData = new FormData();
  formData.append('audio', audioBlob, 'recording.webm');
  formData.append('session_id', sessionId);
  formData.append('tutor_id', tutorId);
  formData.append('language', languageCode);
  formData.append('platform', platform);

  const response = await axios.post(API_URLS.audioMessage, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

  if (!response.data || !response.data.response) {
    throw new Error('Invalid response from server');
  }

  return {
    response: response.data.response,
    transcript: response.data.transcript
  };
};

export const createAudioUrl = (audioContent: string): string => {
  const byteCharacters = atob(audioContent);
  const byteNumbers = new Array(byteCharacters.length);
  
  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }
  
  const byteArray = new Uint8Array(byteNumbers);
  const blob = new Blob([byteArray], { type: 'audio/mp3' });
  return URL.createObjectURL(blob);
};
